var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isDebugMode && _vm.value)?_c('code',{staticClass:"mt-2"},[_vm._v(_vm._s(JSON.stringify(_vm.value, 0, _vm.beautify ? 2 : 0)))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }